export default __webpack_public_path__ + "static/media/rating-top-pick-filled.5c498fad.svg";